<div class="images-carousel">
  <!-- <div class="images-carousel__header">
    <button mat-icon-button class="images-carousel__header__close">
      <mat-icon>close</mat-icon>
    </button>
  </div> -->
  <div class="images-carousel__image-wrapper">
    <button mat-icon-button (click)="prev()" class="images-carousel__arrow images-carousel__arrow--left">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <img [src]="images[currentIndex]" alt="Imagen carrusel" class="images-carousel__image" />

    <button mat-icon-button (click)="next()" class="images-carousel__arrow images-carousel__arrow--right">
      <mat-icon>arrow_forward</mat-icon>
    </button>
  </div>

  <div class="images-carousel__thumbnails">
    <img
      *ngFor="let img of images; let i = index"
      [src]="img"
      class="images-carousel__thumbnail"
      [class.images-carousel__thumbnail--active]="i === currentIndex"
      (click)="select(i)"
      alt="Miniatura {{ i + 1 }}"
    />
  </div>
</div>